import $ from 'jquery';

export default () => {
    const $navSearch = $('.nav-search');
    const $search = $('.search-icon');
    const $navSearchInput = $('.nav-search-input');
    const $navSearchForm = $('.nav-search-form');
    $search.on('click', ()=> {
        $navSearch.toggleClass('open');
        $navSearchInput.focus();
    });

    // Refactor to use a focusout
    function submitListener() {
        const query = $navSearchInput.val();
        window.ga(
            'send',
            'event',
            'SEARCH_QUERY',
            query);

        return this;
    }

    $navSearchForm.on('submit', submitListener);
};
